import { usePathname } from 'next/navigation'

import Button from '@components/buttons/button'

import styles from './menu-links.module.scss'

import type { JSX } from 'react'

export default function MenuLinks({ close }: { close: () => void }): JSX.Element {
  const pathname = usePathname()

  const links = [
    { href: '/', title: 'Home' },
    { href: '/blog', title: 'Blog' },
    { href: '/jobs', title: 'Browse jobs' },
  ]

  return (
    <ul className={styles.links}>
      {links.map((el, i) => (
        <li key={i}>
          <Button variant="simple-text" href={pathname === el.href ? undefined : el.href} onClick={close}>
            {el.title}
          </Button>
        </li>
      ))}
    </ul>
  )
}
